import { baseQueryWithReAuth } from '@apis/baseQueryWithReAuth';
import { createApi } from '@reduxjs/toolkit/query/react';

export const apiSkeletor = createApi({
  reducerPath: 'skeletor',
  baseQuery: baseQueryWithReAuth,
  tagTypes: [
    'PERMISSIONS',
    'ROLES',
    'CLIENTS',
    'TGR',
    'MONTHLY_SALES',
    'INDICATORS',
    'DOCUMENTS',
    'MENUS',
    'MONTHLY_PURCHASES',
    'COMMERCIAL_INVOICES_MANAGEMENT_STATES',
    'CREDIT_LINE_APPLICATION_DETAILS',
    'CREDIT_LINE_APPLICATIONS',
    'CREDIT_LINE_APPLICATIONS_WAITING_FOR_SIGNATURES',
    'CREDIT_LINE_APPLICATIONS_SIGNATURES',
    'CREDIT_LINE_STATUS',
    'REPORTS',
    'OPERATIONS',
    'QUOTE_REQUESTS_INVOICES',
    'QUOTE_REQUEST_STATE_HISTORY',
    'COMMERCIAL_MANAGEMENT_INVOICES',
    'COMMERCIAL_MANAGEMENT_REPORTS',
    'OPERATION_INVOICES',
  ],
  endpoints: () => ({}),
});
